<template>
    <div ref="animation">
    </div>
</template>

<script>
import lottie from 'lottie-web';

export default {
    data() {
        return {}
    },

    mounted() {
        lottie.loadAnimation({
            container: this.$el,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/assets/src/js/lottie/data.json'
        });
    }
}
</script>